import React from 'react';
import { Layout, ProductionBoard } from 'features/command-center';
import usePageTitle from 'hooks/usePageTitle';
import strings from 'strings';
import { PageTitles } from 'UI/constants/defaults';

export const ProductionBoardPage = () => {
  usePageTitle({ title: PageTitles.CommandCenterProductionBoard });

  return (
    <Layout title={strings.commandCenter.productionBoard.title} path={strings.commandCenter.title}>
      <ProductionBoard />
    </Layout>
  );
};
